/**
 * Created by Misa.Qarahqani on 8/21/2019.
 */
import React, {PureComponent} from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {Menu, Dropdown, Icon, Avatar} from 'antd';
import {FormattedMessage} from "react-intl";
import {updateRequest, logoutRequest} from "@actions/auth";
import {ProfileStateI} from "@models/profile";
import Profile from "@components/profile/Profile";
import ChangePassword from "@components/profile/ChangePassword";


export class index extends PureComponent<any, ProfileStateI> {
  logout = () => {
    this.props.logoutRequest({
      access_token: this.props.accessToken,
      onSuccessCallback: () => {
        this.props.history.push("/login");
      },
      onErrorCallback: () => {
        localStorage.clear();
        this.props.history.push("/login");
      }
    })
  }
  
  render() {
    const {name, avatarUrl, userName, email, mobile, id, isActive, updateRequest} = this.props;
    const profile = {
      updateRequest: updateRequest,
      avatar_url: avatarUrl,
      username: userName,
      is_active: isActive,
      mobile: mobile,
      email: email,
      name: name,
      id: id
    };
    const avatarCmp = avatarUrl ? <Avatar src={avatarUrl} size="large"/> : <Avatar icon="user"/>
    const menu = (
      <Menu>
        <Menu.Item key={1}>
          <Icon type="user" className="margin-left-10"/>
          <Profile
            toggleButton={(
              <span><FormattedMessage id="app.profile_setting" defaultMessage={`Settings`}/> </span>)}
            className={'settings-form'}
            profile={profile}
          />
        </Menu.Item>
        <Menu.Item key={2}>
          <Icon type="lock" className="margin-left-10"/>
          <ChangePassword
            toggleButton={(
              <span><FormattedMessage id="app.change_password"
                                      defaultMessage={`Change password`}/> </span>)}
            className={'change-password-form'}
            id={id}
          />
        </Menu.Item>
        <Menu.Item key={3} onClick={this.logout}>
          <Icon type="logout" className="margin-left-10"/>
          <span>
                        <FormattedMessage id="app.exit" defaultMessage={`Exit`}/>
                    </span>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']} overlayClassName={"profile-drop-down"}>
        <a className="ant-dropdown-link profile-header" href="#">
          {avatarCmp}
          <span>{name}</span>
          <Icon type="down"/>
        </a>
      </Dropdown>
    )
  }
}

const mapStateToProps = (state: ProfileStateI) => {
  return {
    avatarUrl: state.auth.user_info.avatar_url,
    userName: state.auth.user_info.username,
    email: state.auth.user_info.email,
    mobile: state.auth.user_info.mobile,
    name: state.auth.user_info.name,
    id: state.auth.user_info.id,
    isActive: state.auth.user_info.is_active,
    accessToken: state.auth.access_token
  }
};
const ProfileContainer: any = connect(mapStateToProps, {updateRequest, logoutRequest})(index);
export default withRouter(ProfileContainer);
